(function() {
    'use strict';

    const TR = angular.module('TR');
    TR.directive('scrollIntoView', scrollIntoView);

    function scrollIntoView($timeout) {
        return {
            restrict: 'A',
            scope: '=',
            compile($element, $attrs) {
                // raw template
                const element = $element[0];
                const showLessbutton = element.querySelector('#seo-lists__showLessButton');
                const showMorebutton = element.querySelector('#seo-lists__showMoreButton');
                const seoListsPanel = element.querySelector('#seo-lists__grid');
                const seoListsContainer = element.querySelector('#seo-lists');

                if (!showLessbutton && !seoListsPanel && !seoListsContainer) { return; }

                const configTimeout = $attrs.timeout && parseInt($attrs.timeout) || '';
                const configDelay = (typeof configTimeout === 'number') ? configTimeout : 0;
                if (configDelay) {
                    seoListsPanel.classList.add('open');
                }

                return function postLink($scope) {

                    const removeOpen = () => {
                        if (seoListsPanel.classList.contains('open')) {
                            seoListsPanel.classList.remove('open');
                        }
                    };

                    const addActive = () => {
                        if (!showMorebutton.classList.contains('active')) {
                            showMorebutton.classList.add('active');
                        }
                    };

                    const wait = (ms = 0) => new Promise(resolve => $timeout(resolve, ms));

                    function handleScrollToView() {
                        seoListsContainer.scrollIntoView();
                    }

                    function scrollToSeoListContainer() {
                        showLessbutton.addEventListener('click', handleScrollToView);
                    }

                    async function delayRemoveOpen() {
                        await wait(configDelay);
                        removeOpen();
                        scrollToSeoListContainer();
                    }

                    function handleError(err) {
                        console.log(err);
                    }

                    $scope.$on('$routeChangeSuccess', function(prev, next, current) {
                        addActive();
                        if (current) {
                            removeOpen();
                            scrollToSeoListContainer();
                        }
                    });

                    window.onload = (function() {
                        if (configDelay) {
                            delayRemoveOpen().catch(handleError);
                        }
                    })();
                };
            }
        };
    }
})();
